//BREEZE-8190 : Basket Order Recommendation : ManasaB : 26-08-2025 : Start
import { memo } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { BzModal, BzModalBody, BzButton, BzModalFooter } from '../../components/';
import { useDispatch, useSelector } from 'react-redux';
import { handleModal, handleModalData } from '../../redux/actions/modals';


const BasketRecoHoldingAlertModal = () => {

    const dispatch = useDispatch();
    const modals = useSelector(state => state?.modals?.modals);
    const objModalData = useSelector(state => state?.modals?.modalData);
    const objBasketRecommendation = useSelector(state => state.recommendation?.objBasketReco);
    const onHandleClose = () => {
        dispatch(handleModal([{ 'BASKET_RECO_HOLDING_ALERT_MODAL': false }]));
    };

    const handleCancel = () => {
        dispatch(handleModal([{ 'BASKET_RECO_HOLDING_ALERT_MODAL': false }, true]));
    };
    const handlePlaceOrder = () => {
        dispatch(handleModal([{ 'ORDER_ENTRY_CONFIRMATION': true }, { 'BASKET_RECO_HOLDING_ALERT_MODAL': false }, true]));
        dispatch(handleModalData({ data: { orderCartConfirmation: objModalData.data.orderCartConfirmation, orderEntryTab: 'multi_scrip', activeTabKey: 'basket', orderCartId: objBasketRecommendation.ordercartId, orderCartName: objBasketRecommendation.ordercartName, orderIdentifier: objModalData.orderIdentifier, orderFrom: 'BASKETRECO' } }));
    };
    return (
        <>
            <BzModal size='sm' show={modals['BASKET_RECO_HOLDING_ALERT_MODAL']} onHide={onHandleClose}>
                <BzModalBody>
                    <Container fluid className='p-0'>
                        <Row className='g-0 mb-3'>
                            <Col className='d-flex justify-content-start'>
                                <div className='font-regular font-size3 color-text'>Holding quantity is not available for scrip(s) :{objModalData.data.scripInfo} DELIVERY SELL order(s) not allowed.Remaining orders can be placed</div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalBody>
                <BzModalFooter>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col className='d-flex justify-content-end'>
                              {objModalData?.data?.orderCartConfirmation?.data?.orderCartInfo?.length > 0 &&  <BzButton className='btn btn-md btn-primary  me-2' onClick={handlePlaceOrder}>Place Order</BzButton>}
                                <BzButton className='btn btn-md btn-outline ms-2' onClick={handleCancel}>Cancel</BzButton>
                            </Col>
                        </Row>
                    </Container>
                </BzModalFooter>
            </BzModal>

        </>
    );
};

export default memo(BasketRecoHoldingAlertModal);

//BREEZE-8190 : Basket Order Recommendation : ManasaB : 26-08-2025 : End
